import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const Stack = styled(FlexCenterY, {
  flexDirection: 'row',
  gap: '0.75rem',
})

export const HeaderRow = styled('div', {
  marginBottom: '1rem',
})

export const ProviderInfo = styled('div', {
  marginBottom: '1rem',
  fontSize: '16px',
  color: '#333',
})

export const FileRow = styled('div', {
  marginBottom: '0.75rem',
})

export const FileLabel = styled('span', ({ $theme }) => ({
  display: 'inline-block',
  padding: '8px 16px',
  backgroundColor: $theme.colors.backgroundTertiary || '#f0f0f0',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '14px',
  ':hover': {
    backgroundColor: $theme.colors.backgroundSecondary || '#e0e0e0',
  },
}))

export const FileName = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '14px',
  color: '#333',
})

export const ClearFileButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: '#999',
  padding: '0 4px',
  lineHeight: 1,
  ':hover': {
    color: '#333',
  },
})

export const ActionsRow = styled('div', {
  marginTop: '0.75rem',
})

export const NotificationsWrapper = styled('div', {
  marginTop: '0.75rem',
})
